export default "__VITE_ASSET__C2iO$Amb__"